import React, { useState } from 'react';
import EnhancedHeader from './components/header/EnhancedHeader';
import HeroCarousel from './components/HeroCarousel';
import NewProducts from './components/NewProducts';
import FeaturedCategories from './components/FeaturedCategories';
import PromoBanner from './components/PromoBanner';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';
import QuickViewModal from './components/QuickViewModal';
import LoginModal from './components/auth/LoginModal';
import RegisterModal from './components/auth/RegisterModal';
import ForgotPasswordModal from './components/auth/ForgotPasswordModal';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from 'react-hot-toast';
import { useCart } from './hooks/useCart';
import './index.css';

function AppContent() {
  const cart = useCart();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isQuickViewOpen, setIsQuickViewOpen] = useState(false);
  const [authModal, setAuthModal] = useState(null); // 'login', 'register', 'forgot'
  const [wishlistCount, setWishlistCount] = useState(0);

  const handleAddToCart = (product) => {
    cart.addItem(product);
  };

  const handleQuickView = (product) => {
    setSelectedProduct(product);
    setIsQuickViewOpen(true);
  };

  return (
    <div className="min-h-screen flex flex-col">
      <EnhancedHeader 
        cartCount={cart.itemCount}
        cartTotal={cart.total}
        wishlistCount={wishlistCount}
        onCartClick={() => cart.setIsOpen(true)}
        onWishlistClick={() => console.log('Wishlist')}
        onLoginClick={() => setAuthModal('login')}
      />
      
      <main className="flex-1">
        <HeroCarousel />
        <NewProducts onAddToCart={handleAddToCart} onQuickView={handleQuickView} />
        <FeaturedCategories />
        <PromoBanner />
      </main>

      <Footer />

      <CartDrawer
        isOpen={cart.isOpen}
        onClose={() => cart.setIsOpen(false)}
        items={cart.items}
        onUpdateQuantity={cart.updateQuantity}
        onRemove={cart.removeItem}
        total={cart.total}
      />

      <QuickViewModal
        product={selectedProduct}
        isOpen={isQuickViewOpen}
        onClose={() => setIsQuickViewOpen(false)}
        onAddToCart={handleAddToCart}
      />

      <LoginModal
        isOpen={authModal === 'login'}
        onClose={() => setAuthModal(null)}
        onSwitchToRegister={() => setAuthModal('register')}
        onSwitchToForgotPassword={() => setAuthModal('forgot')}
      />

      <RegisterModal
        isOpen={authModal === 'register'}
        onClose={() => setAuthModal(null)}
        onSwitchToLogin={() => setAuthModal('login')}
      />

      <ForgotPasswordModal
        isOpen={authModal === 'forgot'}
        onClose={() => setAuthModal(null)}
        onBackToLogin={() => setAuthModal('login')}
      />

      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#fff',
            color: '#1A1A1A',
          },
          success: {
            style: {
              background: '#10B981',
              color: '#fff',
            },
          },
          error: {
            style: {
              background: '#EF4444',
              color: '#fff',
            },
          },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;